// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SITnUgG0HnhTVNpzgtew{display:grid;grid-auto-columns:min-content;grid-auto-flow:column;grid-gap:4px;justify-content:center;list-style-type:none;margin-top:16px !important}.o0P_lhcYOWm1uWDH_EZ3{border:0;border-radius:50%;cursor:pointer;height:12px;padding:0;width:12px}.xMb9jrM5l0EGTCubeTec{background-color:var(--theme-accent-color, #195098)}.jyThWgJjptJybF46AnsQ{background-color:rgba(var(--theme-accent-color--rgb, 25, 80, 152), 0.5)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SITnUgG0HnhTVNpzgtew`,
	"dot": `o0P_lhcYOWm1uWDH_EZ3`,
	"dotActive": `xMb9jrM5l0EGTCubeTec`,
	"dotInactive": `jyThWgJjptJybF46AnsQ`
};
export default ___CSS_LOADER_EXPORT___;
